/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'BeerBrawl';
}
